export default __webpack_public_path__ + "static/media/BH.b4fa22cc.svg";